import { render, staticRenderFns } from "./LmSubTitle.vue?vue&type=template&id=415c016c&scoped=true&"
import script from "./LmSubTitle.vue?vue&type=script&lang=js&"
export * from "./LmSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./LmSubTitle.vue?vue&type=style&index=0&id=415c016c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415c016c",
  null
  
)

export default component.exports